export const StatusPalePalette: any = {
    1: '#C7ECFF',
    2: '#C7ECFF',
    3: '#C7ECFF',
    4: '#C7ECFF',
    5: '#B0EDC0',
    6: '#B0EDC0',
    7: '#FFC5C2',
    8: '#FAAEED',
    9: '#FFD8B8',
    10: '#C7B6FC',
    11: '#BDC3CC',
    12: '#BDC3CC',
}

export const StatusPaleBorderPalette: any = {
    1: '#BAE6FD',
    2: '#BAE6FD',
    3: '#BAE6FD',
    4: '#BAE6FD',
    5: '#9FE9B2',
    6: '#9FE9B2',
    7: '#FDB8B5',
    8: '#F69DE7',
    9: '#FDCFAA',
    10: '#B8A3FA',
    11: '#AEB6C1',
    12: '#AEB6C1',
}